/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageopenevent3Inputs */

const en_ticketpageopenevent3 = /** @type {(inputs: Ticketpageopenevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open event`)
};

const de_ticketpageopenevent3 = /** @type {(inputs: Ticketpageopenevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Event`)
};

/**
* | output |
* | --- |
* | "Open event" |
*
* @param {Ticketpageopenevent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageopenevent3 = /** @type {((inputs?: Ticketpageopenevent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageopenevent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageopenevent3(inputs)
	return de_ticketpageopenevent3(inputs)
});
export { ticketpageopenevent3 as "ticketPageOpenEvent" }